import { motion } from 'framer-motion';
import { Building2 } from 'lucide-react';

export function Partners() {
  const partners = [
    '中国铁建',
    'UPS中国',
    '中粮地产',
    '中免集团',
    '珠江船务',
    '斑马物联网',
    '固德物流',
    '嘉谷万邑',
  ];

  return (
    <section className="py-16 sm:py-20 bg-gradient-to-br from-gray-50 via-orange-50 to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 sm:mb-16"
        >
          <div className="inline-block px-4 py-1 rounded-full bg-orange-100 text-orange-600 text-sm mb-4">
            合作伙伴
          </div>
          <h2 className="text-gray-900 mb-4 px-4">值得信赖的合作伙伴</h2>
          <p className="text-gray-600 max-w-2xl mx-auto px-4">
            与众多500强企业及行业领军品牌建立长期战略合作关系
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
          {partners.map((partner, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              className="group"
            >
              <div className="h-32 flex flex-col items-center justify-center p-6 rounded-xl bg-white border-2 border-gray-200 hover:border-orange-400 hover:shadow-xl transition-all">
                <Building2 className="text-gray-400 group-hover:text-orange-600 mb-3 transition-colors" size={32} />
                <div className="text-gray-800 text-center group-hover:text-orange-600 transition-colors">
                  {partner}
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Stats */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8"
        >
          {[
            { number: '500+', label: '合作企业', color: 'from-orange-600 to-yellow-400' },
            { number: '1000+', label: '成功案例', color: 'from-red-600 to-orange-400' },
            { number: '99%', label: '客户续约率', color: 'from-yellow-600 to-orange-400' },
          ].map((stat, index) => (
            <div
              key={index}
              className={`p-8 rounded-2xl bg-gradient-to-br ${stat.color} text-white text-center shadow-xl`}
            >
              <div className="text-4xl md:text-5xl mb-2">{stat.number}</div>
              <div className="text-white/90">{stat.label}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}